export default __webpack_public_path__ + "static/a6eab89a-db401b0976380c62e170e7d09d4240ad.png";